import { createUseStyles } from 'react-jss';
export const useLinkClasses = createUseStyles({
    link: {
        textDecoration: 'none',
        cursor: 'pointer',
        outline: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
        '&:focus': {
            textDecoration: 'underline',
        },
    },
});
